import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignatureModal = ({ isModal, setModal, onSave }) => {
  const sigRef = useRef();
  const [isEmpty, setIsEmpty] = useState(true);

  if (!isModal) return null;

  // Convert Data URL to File object
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleSave = () => {
    const dataURL = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
const timestamp = Date.now();
const file = dataURLtoFile(dataURL, `signature_${timestamp}.png`);

    onSave(file); // Pass the File object to parent
    setModal(false);
  };

  const handleClear = () => {
    sigRef.current.clear();
    setIsEmpty(true);
  };

  const handleBegin = () => {
    setIsEmpty(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div
        className="w- rounded-t-lg bg-white shadow-lg p-5"
        style={{
          borderRadius: "8px 8px 0 0",
          boxShadow:
            "0 8px 10px -6px rgba(0, 0, 0, 0.10), 0 20px 25px -5px rgba(0, 0, 0, 0.10)",
        }}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-sm font-medium">Your Signature</h2>
          <button
            onClick={() => setModal(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        {/* Signature Box */}
        <div className="relative border border-gray-300 rounded-md h-[150px] mb-2">
          <SignatureCanvas
            ref={sigRef}
            penColor="black"
            onBegin={handleBegin}
            canvasProps={{
              width: 300,
              height: 150,
              className: "rounded-md",
            }}
          />
          {isEmpty && (
            <span className="absolute bottom-1 left-1/2 -translate-x-1/2 text-xs text-gray-400 pointer-events-none">
              Sign here
            </span>
          )}
        </div>

        {/* Clear Button */}
        <div className="text-right mb-4">
          <button
            onClick={handleClear}
            className="text-sm text-blue-500 hover:underline"
          >
            Clear
          </button>
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-between">
          <button
            onClick={() => setModal(false)}
            className="px-4 py-2 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isEmpty}
            className={`px-4 py-2 rounded-md text-white ${
              isEmpty
                ? "bg-blue-300 cursor-not-allowed"
                : "bg-blue-400 hover:bg-blue-500"
            }`}
            style={{ borderRadius: "6px" }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
